module.exports = __webpack_public_path__ + "static/media/nonord-c-9.0aebbcbe.mp3";